import React from 'react';
import AboutTemplate from './AboutTemplate';
import { platformData } from './platformData';

const MobileAppAbout = () => {
  return (
    <AboutTemplate 
      {...platformData.mobileapp}
      platformKey="mobileapp"
    />
  );
};

export default MobileAppAbout; 